(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    const updateMoreFilterLabels = () => {
    document.querySelectorAll('overflow-list').forEach((overflowList) => {
      const morePart = overflowList.shadowRoot?.querySelector('[part="more"]');
      const moreButton = morePart?.querySelector('button');

      if (moreButton && moreButton.textContent.trim() !== 'Más filtros') {
        moreButton.textContent = 'Más filtros';
      }
    });
  };

  updateMoreFilterLabels();

  new MutationObserver(updateMoreFilterLabels).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  } catch(e) { console.error(e); }
})();

})();
